import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AlertService } from "src/app/services/alert.service";
import { FarmerService } from "src/app/services/farmer.service";
import { Router } from "@angular/router";
import { CashBookingService } from "src/app/services/cashbooking.service";
import { EventType } from "src/enum/eventtype";
import * as moment from "moment";
import { MatTableDataSource } from "@angular/material/table";
import { BankcityService } from "src/app/services/bankcity.service";

@Component({
  selector: "app-aeefarmerpaymentpopup",
  templateUrl: "./aeefarmerpaymentpopup.component.html",
  styleUrls: ["./aeefarmerpaymentpopup.component.scss"],
})
export class AeefarmerPaymentpopupComponent implements OnInit {
  showNotes: boolean = true;
  form: FormGroup;
  id: any;
  actionId: any;
  // form: FormGroup;
  isShow: boolean;
  filterCityName: any = [];
  bankName: any;
  bankNameList: any;
  filterbranchName: any[] = [];
  branchName: any[] = [];
  CityName: any[] = [];
  city: boolean = false;
  branch: boolean = false;
  public eventEnum = EventType;
  today: Date;
  subSidyAmount: any;
  loadamounts: number;
  Amountvalid: boolean = false;
  isdisabled: boolean = false;
  maxDate: Date;
  minDate: Date;
  deliveryts: any;
  bookedTs: any;
  event: any;
  eventLength: any;
  lowSubsidy: boolean = false;
  show: boolean = false;
  acNodisable: boolean;
  fileType: number;
  PrintpaymentName: any;
  filesResult: any;
  attachmentlen: any;
  attachmentData: any;
  attachmentsDataSource = new MatTableDataSource([]);
  sort: any;
  paginator: any;
  totalSubsidyAmount: any;
  loading: boolean = false;
  ifscDisabled: boolean = false;
  nonum: boolean = false;
  addSubsidy: any;
  AmountAddvalid: boolean = false;
  lowAddSubsidy: boolean = false;
  stateList: any[];
  filterstateList: any[];

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private farmerService: FarmerService,
    private router: Router,
    public dialogRef: MatDialogRef<AeefarmerPaymentpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    private cashBookingService: CashBookingService,
    private bankcityService: BankcityService
  ) {
    this.id = this.dataRecievedData.sessionId;
    this.actionId = this.dataRecievedData.id;
    this.subSidyAmount = this.dataRecievedData.subSidyAmount;
    (this.deliveryts = this.dataRecievedData.deliveryTs),
      (this.bookedTs = this.dataRecievedData.bookedTs),
      (this.totalSubsidyAmount = this.actionId == 1 ? this.dataRecievedData.totalSubsidyAmount : this.dataRecievedData.additionalSubsidyAmount);
  }

  ngOnInit(): void {
    this.showNotes = true;
    // this.getbankname();
    this.getState();
    this.initializeValidators();
    // this.initializeValidators1();
    this.maxDate = new Date();
    // var date = this.dataRecievedData.deliveryTs;
    this.minDate = new Date(moment(this.bookedTs).format("YYYY, MM, DD"));
    if (this.dataRecievedData?.session?.ifsc) {
      this.form.controls["ifscCode"].setValue(
        this.dataRecievedData.session.ifsc
      );
    }
    if (this.dataRecievedData?.session?.acNo) {
      this.acNodisable = true;
      this.form.controls["accountNo"].setValue(
        this.dataRecievedData?.session?.acNo
      );
    }
    if (this.dataRecievedData?.session?.farmerAccountHolderName) {
      this.form.controls["accountName"].setValue(
        this.dataRecievedData?.session?.farmerAccountHolderName
      );
    }
    if (this.dataRecievedData?.latitude && this.dataRecievedData?.longitude) {
      this.form.controls["latitude"].setValue(this.dataRecievedData?.latitude);
      this.form.controls["longitude"].setValue(this.dataRecievedData?.longitude);
    }

    // if (this.dataRecievedData.additionalSubsidyAmount == 0) {
    //   this.nonum = true
    //   this.form.controls['additionalsubsidyAmount'].setValue(this.dataRecievedData.additionalSubsidyAmount)
    // }
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      dateofTransfer: ["", Validators.required],
      subsidyAmount: ["", Validators.required],
      transferRefNumber: ["", Validators.required],
      utrNumber: ["", Validators.required],
      state: ["", Validators.required],
      bankName: ["", Validators.required],
      ifscCode: ["", Validators.required],
      accountNo: ["", Validators.required],
      accountName: ["", Validators.required],
      branch: ["", Validators.required],
      City: ["", Validators.required],
      latitude: [null],
      longitude: [null]
      // additionalsubsidyAmount: ["", Validators.required]
      // Printpayment:['']
    });
  }
  // initializeValidators1() {
  //   this.form = this.formBuilder.group({
  //     bankName: ['', Validators.required],
  //     ifscCode: ['', Validators.required],
  //     accountNo: ['', Validators.required],
  //     City: ['', Validators.required],
  //     branch: ['', Validators.required],
  //   })
  // }

  next() {
    this.dialogRef.close();
    this.router.navigate(["/aeefarmerbookingview"]);
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  validateFormControl1() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }

  getState() {
    this.bankcityService.getState(true).subscribe((res) => {
      this.stateList = [];
      this.filterstateList = [];
      this.stateList = res;
      this.filterstateList = this.stateList.slice();
      this.form.controls['state'].setValue(31);
      this.getbankname()
    })
  }

  onSave(event: any) {
    let subsidyAmount =
      this.totalSubsidyAmount;
    if (this.form.valid && this.form.value.subsidyAmount == subsidyAmount) {
      this.isdisabled = true;
      this.loading = true;
      let request = {
        id: this.id,
        acNo: "",
        cityId: null,
        branchId: null,
        ifsc: "",
        dbtSchemeId: null,
        dbtComponentId: null,
        dbtProductId: null,
        dbtProductInfoId: null,
        dbtManufacturerId: null,
        dbtDealerId: null,
        eventType: event,
        bankId: null,
        transactionType: 0,
        paymentTs: null,
        receiptNumber: this.form.value.transferRefNumber,
        productCost: 0,
        gstPercentage: 0,
        subsidyAmount: this.form.value.subsidyAmount,
        totalCost: 0,
        engineNumber: "",
        chassisNumber: "",
        registrationNumber: "",
        deliveryTs: moment(this.form.value.dateofTransfer).format("YYYY-MM-DD"),
        remarks: "",
        attachment: [],
        utrNumber: this.form.value.utrNumber,
      };
      this.farmerService.farmerSave(request).subscribe((res) => {
        if (res && res.isSuccess) {
          this.alertService.success(
            "Successfully updated the field subsidy transfer details."
          );
          this.dialogRef.close();
          this.router.navigate(["/aeefarmerbooking"]);
        }
        this.isdisabled = false;
        this.loading = false;
      });
    } else {
      this.validateFormControl();
    }
  }
  onSubmit() {
    debugger
    // if(this.actionId == 1) {
    // this.form.controls["latitude"].setValidators(Validators.required);
    // this.form.controls["latitude"].updateValueAndValidity();
    // this.form.controls["longitude"].setValidators(Validators.required);
    // this.form.controls["longitude"].updateValueAndValidity();
    // }
    
    let subsidyAmount =
      this.totalSubsidyAmount;
    if (this.form.valid) {
      if (this.form.value.subsidyAmount == subsidyAmount) {
        this.isdisabled = true;
        let request = {
          id: this.id,
          dbtSchemeId: null,
          dbtComponentId: null,
          dbtProductId: null,
          dbtProductInfoId: null,
          dbtManufacturerId: null,
          dbtDealerId: null,
          eventType: this.actionId == 1 ? 11 : 12,
          bankId: this.form.value.bankName,
          branchId: this.form.value.branch,
          cityId: this.form.value.City,
          ifsc: this.form.value.ifscCode.toString(),
          acNo: this.form.value.accountNo.toString(),
          accountHolderName: this.form.value.accountName.toString(),
          transactionType: 0,
          paymentTs: moment(this.form.value.dateofTransfer).format(
            "YYYY-MM-DD"
          ),
          receiptNumber: this.form.value.transferRefNumber,
          productCost: 0,
          gstPercentage: 0,
          subsidyAmount: this.actionId == 1 ? this.form.value.subsidyAmount : 0,
          additionalSubsidyAmount: this.actionId == 2 ? this.form.value.subsidyAmount : 0,
          totalCost: 0,
          engineNumber: "",
          chassisNumber: "",
          registrationNumber: "",
          deliveryTs: moment(this.form.value.dateofTransfer).format(
            "YYYY-MM-DD"
          ),
          remarks: "",
          utrNumber: this.form.value.utrNumber,
          attachment: [],          
          latitude:this.form.value.latitude  ?? 0,
          longitude:this.form.value.longitude ?? 0
          //   dateofTransfer: ['', Validators.required],
          // subsidyAmount: ['', Validators.required],
          // transferRefNumber: ['', Validators.required],
          // utrNumber:['', Validators.required],
          // bankName: ['', Validators.required],
          // ifscCode: ['', Validators.required],
          // accountNo: ['', Validators.required],
          // accountName: ['', Validators.required],
          // branch: ['', Validators.required],
          // City: ['', Validators.required],
        };
        this.farmerService.farmerSave(request).subscribe((res) => {
          if (res && res.isSuccess) {
            this.isdisabled = false;
            this.alertService.success(this.actionId == 1 ?
              "Successfully updated the field subsidy transfer details." : "Successfully updated the field additional subsidy transfer details."
            );
            this.dialogRef.close();
            this.router.navigate(["/aefarmerbooking"]);
          } else {
            this.isdisabled = false;
          }
        });
        // } 
        // else {
        //   this.alertService.warning(
        //     "Additional Subsidy Amount Is Mismatched."
        //   )
        // }
      }
      else {
        this.alertService.warning(
          this.actionId == 1 ?
            "Subsidy Amount Is Mismatched." : "Additional Subsidy Amount Is Mismatched."
        )
      }
    } else {
      this.isdisabled = false;
      this.validateFormControl1();
      this.alertService.error(
        "Please fill the required fields ."
      )
    }
  }
  getbankname() {
    this.filterCityName = [];
    this.bankName = [];
    this.bankNameList = [];
    this.filterCityName = [];
    this.CityName = [];
    this.branchName = [];
    this.filterbranchName = [];
    this.form.controls["ifscCode"].setValue(null);
    this.form.controls["branch"].setValue(null);
    this.form.controls["City"].setValue(null);
    this.form.controls["bankName"].setValue(null);
    this.bankcityService.getBank(this.form.value.state, true).subscribe((res) => {
      this.bankName = res.filter((i: { key: number }) => i.key);
      this.bankNameList = this.bankName;
      // this.form.controls["bankName"].setValue(0);

      if(this.bankNameList.length==1)
      {
        this.form.controls['bankName'].setValue(this.bankNameList[0].key);
        this.getcity();

      }
      if (this.dataRecievedData?.session?.farmerBankId > 0) {
        this.form.controls["bankName"].setValue(
          this.dataRecievedData?.session?.farmerBankId
        );
        this.getcity();
      }
    });
  }

  getcity() {
    this.filterCityName = [];
    this.CityName = [];
    this.branchName = [];
    this.filterbranchName = [];
    this.bankcityService.getCity(this.form.value.state, this.form.value.bankName, true)
      .subscribe((res) => {
        this.CityName = res;
        this.filterCityName = this.CityName;
        this.form.controls["branch"].setValue(null);
        this.form.controls["ifscCode"].setValue(null);
        if(this.CityName.length==1)
      {
        this.form.controls['City'].setValue(this.CityName[0].key);
        this.getbranch();
      }
        if (this.dataRecievedData?.session?.farmerCityId > 0) {
          this.form.controls["City"].setValue(
            this.dataRecievedData?.session?.farmerCityId
          );
          this.getbranch();
        }
      });
  }
  getbranch() {
    this.branchName = [];
    this.filterbranchName = [];
    this.farmerService
      .getbranch(this.form.value.City, true)
      .subscribe((res) => {
        this.branchName = res;
        this.filterbranchName = this.branchName;
        this.form.controls["ifscCode"].setValue(null);
        if(this.branchName.length==1)
        {
          this.form.controls['branch'].setValue(this.branchName[0].key);
          this.ifscno(this.form.value.branch);
        }
        if (this.dataRecievedData?.session?.farmerBranchId > 0) {
          this.form.controls["branch"].setValue(
            this.dataRecievedData?.session?.farmerBranchId
          );
          this.ifscno(this.form.value.branch);
        }
      });
  }
  ifscno(event: any) {
    var list = this.filterbranchName.filter((i) => i.key == this.form.value.branch);
    this.form.controls["ifscCode"].setValue(list.length ? list[0].ifsc : null);
  }
  // Typing a full 11-character IFSC patches bank, city and branch; each can still be changed afterwards
  onIfscInput() {
    const ifsc = (this.form.value.ifscCode || "").toString().trim().toUpperCase();
    if (ifsc !== this.form.value.ifscCode) {
      this.form.controls["ifscCode"].setValue(ifsc, { emitEvent: false });
    }
    if (ifsc.length !== 11) { return; }
    this.bankcityService.getIfscDetails(ifsc).subscribe((d) => {
      if (!d || !d.branchId || this.form.value.ifscCode !== ifsc) { return; }
      this.bankcityService.getBank(this.form.value.state, true).subscribe((banks) => {
        this.bankName = banks.filter((i: { key: number }) => i.key);
        this.bankNameList = this.bankName;
        this.bankcityService.getCity(this.form.value.state, d.bankId, true).subscribe((cities) => {
          this.CityName = cities;
          this.filterCityName = cities;
          this.farmerService.getbranch(d.cityId, true).subscribe((branches) => {
            this.branchName = branches;
            this.filterbranchName = branches;
            this.form.patchValue({ bankName: d.bankId, City: d.cityId, branch: d.branchId });
          });
        });
      });
    });
  }

  otp() {
    this.show = true;
  }

  keyUp(event) {
    this.event = event;
    this.eventLength = event?.target?.value?.length;
  }

  // additionalSubsidy() {
  //   this.addSubsidy = this.form.value.additionalsubsidyAmount;
  //   let value = this.dataRecievedData.additionalSubsidyAmount
  //   if (this.addSubsidy > value) {
  //     this.AmountAddvalid = true;
  //     this.lowAddSubsidy = false;
  //   } else if (this.addSubsidy < value) {
  //     this.lowAddSubsidy = true;
  //     this.AmountAddvalid = false;
  //   } else {
  //     this.AmountAddvalid = false;
  //     this.lowAddSubsidy = false;
  //   }
  // }

  onKeyUp() {
    this.loadamounts = parseInt(this.form.value.subsidyAmount);
    if (this.loadamounts > (this.totalSubsidyAmount)) {
      this.Amountvalid = true;
      this.lowSubsidy = false;
    } else if (this.loadamounts < (this.totalSubsidyAmount)) {
      this.lowSubsidy = true;
      this.Amountvalid = false;
    } else {
      this.Amountvalid = false;
      this.lowSubsidy = false;
    }
  }
  // PrintpaymentSelected(event1){
  //   const file = event1.target.files[0];
  //   let ext = file.name.split('.').pop();
  //   if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
  //     // if (this.attachmentlen.length < 3) {
  //       if (ext !== 'pdf') {
  //         this.fileType = 1;
  //       } else {
  //         this.fileType = 2;
  //       }
  //       this.PrintpaymentName = file.name;
  //       let filesize = file.size;
  //       let acceptsize = parseInt((filesize / 1024).toFixed(2));
  //       if (acceptsize < 1000) {
  //         if (event1.target.files && event1.target.files[0]) {
  //           const reader = new FileReader();
  //           reader.readAsDataURL(event1.target.files[0]);
  //           reader.onload = (event: any) => {
  //             this.filesResult = event.target.result.split(',')[1];
  //             if (this.filesResult) {

  //               this.form.controls['Printpayment'].setValue(this.filesResult);
  //               this.form.controls['ChasPrintpaymentsisno'].setValue(this.filesResult ? this.PrintpaymentName : ''); // <-- Set Value for Validation
  //             }
  //             this.attachmentlen.push({ id: 0 });

  //             this.attachmentData.push({
  //               id: 0,
  //               attachmentFilename: this.PrintpaymentName,
  //               base64String: this.filesResult,
  //               // attachmentPath: "string",
  //               attachmentType:47,
  //               statusType: 2,
  //               fileType: this.fileType
  //             });
  //             this.attachmentsDataSource.data = this.attachmentData.filter(e => e.statusType !== 3);
  //             this.attachmentsDataSource.sort = this.sort;
  //             this.attachmentsDataSource.paginator = this.paginator;
  //           }
  //         }
  //       } else {
  //         this.alertService.error('File size is large, Please upload less than 2 MB');
  //         this.PrintpaymentName = '';
  //       }
  //     // } else {
  //     //   this.alertService.error('limit exceeded while uploading more than 3 images');
  //     // }
  //   }
  //   else {
  //     this.alertService.error('Please upload  JPG & PNG images');
  //   }
  // }
  // clear(event) {
  //   event.target.value = null;
  // }
}
